import axios, { AxiosError, AxiosResponse } from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL || "https://localhost:8080";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,   //1 minute timeout
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient?.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem("accessToken");
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

apiClient?.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized. Redirecting to login...");
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
